/** Trace colour matches zip HolesLoader: status first, then hole type. */
export function isPlannedHole(row) {
  const id = String(row?.Hole_ID ?? row?.holeID ?? row?.holeId ?? '').trim();
  return /p$/i.test(id);
}

export function holeTraceColor(row) {
  if (!row) return '#000000';
  if (isPlannedHole(row) || row.Hole_Type === 'DD_PLAN') return '#ffffff';
  if (row.Hole_Status === 'DRILLED') return '#008000';
  if (String(row.Hole_Type || '').includes('DD_SFN_DEFLECTION')) return '#71797E';
  if (row.Hole_Type === 'LOM_DD') return '#87ceeb';
  return '#000000';
}
